import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import useMutationCreateCommentOnActivityAssignment from 'hooks/activities/useMutationCreateCommentOnActivityAssignment';
import { ActivityAssignmentData } from 'hooks/activities/useQueryActivityAssignments';
import CommentModal from 'components/CommentModal/CommentModal';
import { CommentFormData } from 'components/CommentModal/CommentForm';

interface CommentOnActivityAssignmentProps {
  activityAssignment: ActivityAssignmentData;
  text?: string;
}

type Props = CommentOnActivityAssignmentProps;

const CommentOnActivityAssignment = ({ activityAssignment, text }: Props) => {
  const [createCommentOnActivityAssignment, { data: mutationData, loading, error }] =
    useMutationCreateCommentOnActivityAssignment();

  const handleCommentOnActivity = useCallback(
    async (data: CommentFormData) => {
      const defaultRecipientIds = activityAssignment.assignedUser
        ? [activityAssignment.assignedUser.id]
        : [];

      const result = await createCommentOnActivityAssignment({
        variables: {
          input: {
            recipientIds:
              data.recipientIds && data.recipientIds.length > 0
                ? data.recipientIds
                : defaultRecipientIds,
            activityAssignmentId: activityAssignment.id,
            comment: data.comment,
          },
        },
      });

      return result.data?.createCommentOnActivityAssignment.success ?? false;
    },
    [activityAssignment.assignedUser, activityAssignment.id, createCommentOnActivityAssignment]
  );

  return (
    <>
      <CommentModal
        onSubmit={handleCommentOnActivity}
        buttonText={text}
        loading={loading}
        error={error?.message || mutationData?.createCommentOnActivityAssignment?.error}
      >
        <Typography variant='h5'>Comment on Activity</Typography>
        Recipients will receive a link to this task.
      </CommentModal>
    </>
  );
};

export default CommentOnActivityAssignment;
